import CzymJestImg from './assets/articles/czym-jest.jpg';
import WhyCheckKwImg from './assets/articles/dlaczego-sprawdz.jpg';
import WhatIsEkwImg from './assets/articles/what-is-ekw.jpg';
import WhatChangesKwImg from './assets/articles/what-changes.jpg';

import WhatIsKw from "./screens/knowledge-base/articles/what-is-kw";
import WhyCheckKw from "./screens/knowledge-base/articles/why-check-kw";
import WhatIsEkw from "./screens/knowledge-base/articles/what-is-ekw";
import WhatChangesKw from "./screens/knowledge-base/articles/what-changes-kw";

export const articles = [
    {
        title: 'Czym jest księga wieczysta',
        url: '/baza-wiedzy/czym-jest-ksiega-wieczysta',
        image: CzymJestImg,
        date: '12.03.2025',
        timeToRead: 4,
        metaDescription: 'Poznaj podstawowe informacje o księdze wieczystej – oficjalnym rejestrze nieruchomości, który umożliwia weryfikację stanu prawnego obiektów.',
        metaKeywords: 'księga wieczysta, rejestr nieruchomości, prawo własności, hipoteki, obciążenia',
        component: WhatIsKw
    },
    {
        title: 'Dlaczego trzeba sprawdzić księgę wieczystą przed zakupem nieruchomości',
        url: '/baza-wiedzy/dlaczego-sprawdzac-ksiege-wieczysta-przed-zakupem-nieruchomosci',
        image: WhyCheckKwImg,
        date: '12.03.2025',
        timeToRead: 3,
        metaDescription: 'Dowiedz się, dlaczego weryfikacja księgi wieczystej jest kluczowa przed zakupem nieruchomości i jak chronić swoją inwestycję przed nieprzewidzianymi problemami prawnymi.',
        metaKeywords: 'sprawdzanie księgi wieczystej, bezpieczeństwo nieruchomości, analiza stanu prawnego, inwestycje',
        component: WhyCheckKw
    },
    {
        title: 'Czym jest elektroniczna księga wieczysta',
        url: '/baza-wiedzy/czym-jest-elektroniczna-ksiega-wieczysta',
        image: WhatIsEkwImg,
        date: '12.03.2025',
        timeToRead: 3,
        metaDescription: 'Odkryj, czym jest elektroniczna księga wieczysta, jakie korzyści niesie cyfryzacja rejestru oraz jak system ten wpływa na przejrzystość rynku nieruchomości.',
        metaKeywords: 'elektroniczna księga wieczysta, cyfrowy rejestr, nieruchomości, technologia, prawo',
        component: WhatIsEkw
    },
    {
        title: 'Co najczęściej się zmienia w księdze wieczystej i dlaczego warto to sprawdzać',
        url: '/baza-wiedzy/najczestsze-przyczyny-zmian-w-ksiedze-wieczystej',
        image: WhatChangesKwImg,
        date: '24.04.2025',
        timeToRead: 3,
        metaDescription: 'Dowiedz się, jakie zmiany najczęściej pojawiają się w księdze wieczystej oraz dlaczego regularna weryfikacja wpisów jest kluczowa dla ochrony Twoich praw i bezpieczeństwa transakcji.',
        metaKeywords: 'zmiany w księdze wieczystej, weryfikacja księgi wieczystej, obciążenia nieruchomości, zabezpieczenia prawne, służebności, hipoteki',
        component: WhatChangesKw
    }
];
